module.exports = __webpack_public_path__ + "img/1tlaxcala_07.459e54d7.png";